export default __webpack_public_path__ + "11.fff274.svg";